<div class="d-flex w-100 h-100 justify-content-center align-items-center">
  <mat-card>
    <mat-card-header style="justify-content:center">
      <mat-card-title>
        <div class="row">
          <div class="col-12 text-center">
            <h1 class="fw-semibold col-12 text-center mt-2">
              Welcome to Portal
              <img src="../../../../assets/img/tonic-dots.png"
                   alt="Tonic logo"
                   width="50">
            </h1>
          </div>
        </div>
      </mat-card-title>
      <mat-card-subtitle class="justify-content-center">ENTER YOUR INFORMATION</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="inviteForm">

        <mat-form-field appearance="outline" style="grid-area: firstName; margin-right: 5px">
          <mat-label>First Name</mat-label>
          <input matInput type="text" formControlName="first"/>
          <mat-error>First name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="grid-area: lastName; margin-left: 5px">
          <mat-label>Last Name</mat-label>
          <input matInput type="text" formControlName="last"/>
          <mat-error>Last name is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="grid-area: email">
          <mat-label>Email</mat-label>
          <input matInput type="email" formControlName="email"/>
          <mat-error *ngIf="getFormControl(inviteForm, 'email').hasError('required')">Email is required</mat-error>
          <mat-error *ngIf="getFormControl(inviteForm, 'email').hasError('email')">Please enter a valid email</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="grid-area: phone">
          <mat-label>Phone</mat-label>
          <input matInput type="tel" formControlName="phone" mask="(000) 000-0000" style="text-align: center" [showMaskTyped]="true"/>
          <mat-error *ngIf="getFormControl(inviteForm, 'phone').hasError('required')">Phone is required</mat-error>
          <mat-error *ngIf="getFormControl(inviteForm, 'phone').hasError('minlength')">Phone number is not valid</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="grid-area: password">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password"/>
          <mat-error>Password is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="grid-area: conPassword">
          <mat-label>Confirm Password</mat-label>
          <input matInput type="password" formControlName="confirmedPassword"/>
          <mat-error *ngIf="getFormControl(inviteForm,'confirmedPassword').hasError('required')">Password required</mat-error>
          <mat-error *ngIf="getFormControl(inviteForm,'confirmedPassword').hasError('noMatch')">Passwords don't match</mat-error>
        </mat-form-field>

      </form>

      <button
        mat-flat-button
        color="primary"
        style="width: 100%; margin-bottom: 10px"
        (click)="onRegister()"
        [disabled]="inviteForm.invalid">Register</button>

      <mat-divider [inset]="true"></mat-divider>

      <mat-card-footer>© {{currentYr}} - Tonic. All rights reserved</mat-card-footer>
    </mat-card-content>

  </mat-card>
</div>
